import Icon from '../components/Icon.vue'

Icon.register({"fast-forward":{"width":512,"height":512,"paths":[{"d":"M512 76V436C512 442.6 506.6 448 500 448H460C453.4 448 448 442.6 448 436V284.1L276.5 440.6C255.9 457.8 224 443.4 224 416V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96C0 68.6 31.9 54.3 52.5 71.4L224 226.8V96C224 68.6 255.9 54.3 276.5 71.4L448 226.8V76C448 69.4 453.4 64 460 64H500C506.6 64 512 69.4 512 76z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/fast-forward.js